// extracted by mini-css-extract-plugin
module.exports = {"root":"PaymentRefPage_root__1sKsf","title":"PaymentRefPage_title__3TG0d"};